import React from "react";
import { FieldHeading } from "./FieldHeading.js";

type Props = {
  vatIncome: number;
};

/**
 * Generates table rows for the VAT report field 13.
 */
export const VatReportField13 = ({ vatIncome }: Props) => {
  return (
    <FieldHeading label="Väli 13" description="Enammakstud käibemaks" total={vatIncome} itemsCount={0} />
  );
};
